import type { CrmListObjectType } from "../../crm-integration/types/object-type";
import type { CrmIntegrationProvider } from "../../crm-integration/types/provider";
import type { CrmListId } from "../types/list";

export const makeCrmListId = (crm: CrmIntegrationProvider, objectType: CrmListObjectType): CrmListId =>
    `${crm}-${objectType}`;
